import { BaseRootStore } from '../../../rootStore/baseRootStore';
import type UserStore from '../../UserStore';

/**
 * Calculates the total fields area by summing the user's total area
 * and the area of all unique users in the organizations owned by the user.
 */
export const calculateTotalUsedArea = (
  userDataTotalArea: number | null,
  organizations: UserStore<BaseRootStore>['userDataOrganizations']['orgs'],
  ownerUuid: string,
): number => {
  const uniqueUsers = new Set<string>();

  const orgUsersArea = organizations?.reduce((orgsSum, org) => {
    if (org?.ownerUuid !== ownerUuid) {
      return orgsSum;
    }

    const usersArea = (org?.users ?? []).reduce((usersSum, user) => {
      if (!user?.userUuid || uniqueUsers.has(user.userUuid)) {
        return usersSum;
      }

      uniqueUsers.add(user.userUuid);

      return usersSum + (user?.totalArea ?? 0);
    }, 0);

    return orgsSum + usersArea;
  }, 0);

  const totalUsedArea = (orgUsersArea ?? 0) + (userDataTotalArea ?? 0);

  return totalUsedArea;
};
